/*
  Карточка счёта: чтение, перечитывание после действия, смена счёта.

  Вынесено из `pages/AccountPage.jsx` 27.10.2026 (предел размера страницы). Правила те же,
  что сложились на странице:

  - ответ на устаревший запрос выбрасывается (аудит 26.10.2026, причина 5): перечитывание
    после действия и переход на другой счёт шли без отметки, и запоздавший ответ прежнего
    счёта оседал под новым. `latest` помнит номер последнего запроса; ответ с другим
    номером ни карточку, ни ошибку не меняет;
  - другой счёт - другая карточка: прежняя не остаётся на экране, пока грузится новая;
  - сбой перечитывания карточку не стирает (причина 1): `error` отдаётся рядом с ней, а
    экран решает, где его показать.
*/

import { useCallback, useEffect, useRef, useState } from 'react'

import { api } from '../api/client.js'

export default function useAccountCard(accountId) {
  const [card, setCard] = useState(null)
  const [error, setError] = useState(null)
  const latest = useRef(0)

  const reload = useCallback(() => {
    const mine = (latest.current += 1)
    setError(null)
    api
      .account(accountId)
      .then((result) => {
        if (mine === latest.current) setCard(result)
      })
      .catch((failure) => {
        if (mine === latest.current) setError(failure)
      })
  }, [accountId])

  useEffect(() => {
    setCard(null)
  }, [accountId])

  useEffect(() => {
    reload()
    return () => {
      latest.current += 1
    }
  }, [reload])

  return { card, error, reload }
}
